module.exports = __webpack_public_path__ + "static/media/biocore-complete-pack.8d791b87.png";